/**
 * Normalizes a value to a number, handling string inputs with commas
 * @param value - The value to normalize
 * @returns The normalized number value
 */
export const normalizeNumber = (value: string | number | undefined): number => {
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace(',', '.'));
    return isNaN(parsed) ? 0 : parsed;
  }
  return value || 0;
};

/**
 * Normalizes a value to an integer, handling string inputs
 * @param value - The value to normalize
 * @returns The normalized integer value
 */
export const normalizeInteger = (
  value: string | number | undefined
): number => {
  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
  }
  return value || 0;
};
